import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { PersonInterface } from './person-interface';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  constructor(private http: HttpClient) { }

  run(person: PersonInterface,uri: string): Observable<any> {
    const url = `${environment.baseUrl}/${uri}`;
    const jsonUserAccount = JSON.stringify(person);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(url, person, { headers });
  }

}
